import React from 'react'
import axios from 'axios'
import { jsonToFormData } from '../../../utilities'
import { useToasts } from 'react-toast-notifications'

const useGetManagement = () => {
  const [managementData, setManagementData] = React.useState()
  const [backEndErrors, setBackEndErrors] = React.useState({})
  const { addToast } = useToasts()

  const getManagementData = async rawData => {
    const data = rawData ? jsonToFormData(rawData) : rawData
    axios({
      method: 'post',
      url: `v1/management-information`,
      data: data,
    })
      .then(response => {
        if (response.status === 200) {
          setManagementData(response.data)
        } else {
          setBackEndErrors({
            error: 'Error receiving management data, please try again',
            appearance: 'error',
          })
          addToast(`Error getting Management information, please try again`, {
            appearance: 'error',
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
          addToast(`Error getting Management information, please try again`, {
            appearance: 'error',
          })
        } else {
          setBackEndErrors(error.response.data.error)
          addToast(`Error getting Management information, please try again`, {
            appearance: 'error',
          })
        }
      })
  }

  return { managementData, setManagementData, getManagementData, backEndErrors }
}

export default useGetManagement
